import Swiper from 'swiper/bundle';

export default function initSwiperHeroProduct(playersInstance) {
    playersInstance.swiperHeroProduct = new Swiper(".swiperHeroProduct", {
        grabCursor: true,
        effect: "creative",
        creativeEffect: {
            prev: {
                shadow: true,
                translate: ["-20%", 0, -1],
            },
            next: {
                translate: ["100%", 0, 0],
            },
        },
        navigation: {
            nextEl: ".block-hero-product .swiper-next",
            prevEl: ".block-hero-product .swiper-prev",
        },
        on: {
            slideChange: () => {
                playersInstance.pauseCurrentVideo();
                playersInstance.removePlayingClass();
            },
            beforeChange: () => {
                playersInstance.pauseCurrentVideo();
                playersInstance.removePlayingClass();
            },
        },
    });
}
